import React from "react";
import { toast, } from 'react-toastify';
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import axios from "axios"

class CreatePasswordPage extends React.Component {

  state = {
    cardAnimaton: "cardHidden",
    password: "",
    confirmPassword: "",
    errors: {
      password: "",
      confirmPassword: "",
    },
  };

  componentDidMount() {
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case "password":
        errors.password = value.length > 5 ? "" : "Password must be 6 characters long!";
        break;
      case "confirmPassword":
        errors.confirmPassword = value.length > 5 ? "" : "Password must be 6 characters long!";
        if(this.state.password !== value){
          errors.confirmPassword = "Password do not match!";
        }
        break;
      default:
        break;
    }
    this.setState({ errors, [name]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    axios.post('http://3.136.175.105:8080/api/admin/resetPassword', {
      email_address: this.props.location.state.email_address,
      password: this.state.password
    })
    .then(_ => {
      toast.success("Password changed Successfully!")
      this.props.history.push('login-page');
    })
    .catch(err => {
      toast.error("Some Error Happened")
    })
  }

  disableSpacebar = (e) => {
    if(e.keyCode === 32){
        e.preventDefault();
    }
  }


  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form noValidate onSubmit={this.handleSubmit}>
              <Card login className={classes[this.state.cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="success"
                >
                  <h4 className={classes.cardTitle}>Create New Password</h4>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText="Enter new password..."
                    id="password"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      name: "password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}>
                            lock_outline
                          </Icon>
                        </InputAdornment>
                      ),
                      type: "password",
                      onChange: this.handleChange,
                      onKeyDown: (e) => this.disableSpacebar(e)
                    }}
                  />
                  {this.state.errors.password && <p style={{color: "red", margin: 0, fontSize: "12px"}}>{this.state.errors.password}</p>}
                  <CustomInput
                    labelText="Confirm new password..."
                    id="confirmPassword"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      name: "confirmPassword",
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}>
                            lock_outline
                          </Icon>
                        </InputAdornment>
                      ),
                      type: "password",
                      onChange: this.handleChange,
                      onKeyDown: (e) => this.disableSpacebar(e)
                    }}
                  />
                  {this.state.errors.confirmPassword && <p style={{color: "red", margin: 0, fontSize: "12px"}}>{this.state.errors.confirmPassword}</p>}
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                  <Button onClick={() => this.props.history.goBack()} color="success" simple size="lg" block style={{color: "#fff", backgroundColor: "#4caf50"}}>
                    BACK
                  </Button>
                  <Button onClick={this.handleSubmit} color="success" simple size="lg" block style={{color: "#fff", backgroundColor: "#4caf50"}} disabled={this.state.errors.password.length>0 || this.state.errors.confirmPassword.length>0 || !this.state.password || !this.state.confirmPassword}>
                    SUBMIT
                  </Button>
                </CardFooter>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(CreatePasswordPage);
